import { useNavigate } from "@tanstack/react-router";
import { Building2, CheckCircle2 } from "lucide-react";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import Loading from "@/components/Loading";

export function InvitationPendingAcceptCard({
  organizationName,
  businessUnitName,
  onAccept,
  isAccepting,
  errorMessage,
  justAccepted,
}: {
  organizationName: string;
  businessUnitName: string;
  onAccept: () => void;
  isAccepting: boolean;
  errorMessage?: string;
  justAccepted: boolean;
}) {
  const navigate = useNavigate();

  if (justAccepted) {
    return (
      <>
        <CardHeader className="items-center text-center">
          <div className="rounded-full bg-green-100 p-3 mb-2">
            <CheckCircle2 className="h-6 w-6 text-green-600" />
          </div>
          <CardTitle className="text-xl">You&apos;re in</CardTitle>
          <CardDescription>
            You&apos;ve joined {businessUnitName}&apos;s provider roster. Taking
            you to your workspace…
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            className="w-full"
            onClick={() => navigate({ to: "/provider/home" })}
          >
            Continue
          </Button>
        </CardContent>
      </>
    );
  }

  return (
    <>
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-blue-100 p-3 mb-2">
          <Building2 className="h-6 w-6 text-blue-600" />
        </div>
        <CardTitle className="text-xl">You&apos;re invited</CardTitle>
        <CardDescription>
          {organizationName} invited you to join {businessUnitName}&apos;s
          provider roster on Saile.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {errorMessage && (
          <Alert variant="destructive">
            <AlertDescription>{errorMessage}</AlertDescription>
          </Alert>
        )}
        <Button className="w-full" onClick={onAccept} disabled={isAccepting}>
          {isAccepting ? <Loading className="h-5 w-5" /> : "Accept invitation"}
        </Button>
      </CardContent>
    </>
  );
}
